const React = require('react');
import PropTypes from 'prop-types';
const uniq = require('lodash/array/uniq');


//@components
const { formatText } = require('core/i18n').i18n;
const PopoverNavigationButton = require('components/commons/popoverNavigationButton/popoverNavigationButton');
//@constants
const getCardsProductBanners = require('constants/productBanners/cardsProductBanners');
const { CARDS_PRODUCT } = require ('constants/contactCenter/cardsProduct');
const {
    HORMIGUERO_CARD,
    VIRTUAL_CREDIT_CARD,
    VIRTUAL_DEBIT_CARD,
    OPEN_YOUNG,
    OPEN_DEBIT_CARD,
    METALLIC_CARD,
    MAESTRO_CARD,
    NERUDA_CARD,
    VANITY_CARD
} = require('constants/flagBasedFeatures');
const {
    OPEN_YOUNG_PACK_KEY,
} = require('constants/index');
// @ helpers
const { canHireCard } = require('utilities/hireCardsHelper');
// @utilities
const { nonNumericFilter } = require('utilities/stringHelper');
// @hocs
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';

class CardsProductDropdown extends React.Component {
    constructor(props) {
        super(props)

        this.CARDS_PRODUCT_BANNERS_ORDER = [ // Order required by client
            //type => subtype
            'diamondPack',
            'premiumPack',
            '500801',//open credit
            '500003',//revolving
            '500803',//virtualcredit
            '532001',//via t
            //...(__CONTACT_CENTER__ ? [] :['506003']),//ecard OPE444-7091 hide ecard option for CC
            '506010',//openyoung
            OPEN_YOUNG_PACK_KEY,
            '506002',//open debit
            //...(__CONTACT_CENTER__ ? [] :['506005']), // at home abroad, hidden for CC
            '506011', //solidaria card
            '506012',//Virtual Debit Card
            'maestro', // maestro card
            'metallic', // Metallic Card
            '500804', // Hormiguero Card
            '500802', // Neruda Card
            '500805', // Vanity Card
        ];
    }

    getUserOwnedProductBannersCode = immCards => {
        const output = [];

        immCards.get('byId').forEach(immCard => {
            const newProduct = immCard.get('newProduct');
            const productSubType = immCard.get('productSubType');
            const cardType = nonNumericFilter(newProduct + productSubType);

            if (this.CARDS_PRODUCT_BANNERS_ORDER.includes(cardType)) {
                output.push(cardType);
            } else if (cardType === '501003' || cardType === '506009') {// 501003 - premiumPack credit / 506009 - premiumPack debit
                output.push('premiumPack');
            } else if (cardType === '501002' || cardType === '506008') {// 501002 - diamondPack credit / 506008 - diamondPack debit
                output.push('diamondPack');
            }

        });

        return uniq(output);
    }



    getProductBannersOrder = userCardsAdvertisementTypes => {
        const accountTypesContractedByUser = [];
        const accountTypesNonContractedByUser = [];

        this.CARDS_PRODUCT_BANNERS_ORDER.forEach(accountType => {
            if (userCardsAdvertisementTypes.includes(accountType)) {
                accountTypesContractedByUser.push(accountType);
            } else {
                accountTypesNonContractedByUser.push(accountType);
            }
        })

        return accountTypesNonContractedByUser.concat(accountTypesContractedByUser);
    }

    showCardProductByFeatureToggling = identifier => {
        const { flagBasedFeatures } = this.props
        let response = true

        switch (identifier) {
            case CARDS_PRODUCT.VIRTUAL_ONLY_CREDIT:
                response = flagBasedFeatures.get(VIRTUAL_CREDIT_CARD)
                break;

            case CARDS_PRODUCT.VIRTUAL_DEBIT_CARD:
                response = flagBasedFeatures.get(VIRTUAL_DEBIT_CARD)
                break;

            case CARDS_PRODUCT.OPEN_YOUNG:
                response = flagBasedFeatures.get(OPEN_YOUNG)
                break;

            case CARDS_PRODUCT.MAESTRO_CARD:
                response = flagBasedFeatures.get(MAESTRO_CARD)
                break;

            case CARDS_PRODUCT.METALLIC_CARD:
                response = flagBasedFeatures.get(METALLIC_CARD)
                break;
            
            case CARDS_PRODUCT.OPEN_DEBIT_CARD:
                response = flagBasedFeatures.get(OPEN_DEBIT_CARD)
                break;

            case CARDS_PRODUCT.NERUDA_CARD:
                response = flagBasedFeatures.get(NERUDA_CARD)
                break;

            case CARDS_PRODUCT.VANITY_CARD:
                response = flagBasedFeatures.get(VANITY_CARD)
                break;

            case CARDS_PRODUCT.HORMIGUERO_CARD:
                    response = flagBasedFeatures.get(HORMIGUERO_CARD)
                    break;

            default:
                response = true
                break;
        }

        return response
    }

    buildProductDropdown(orderedProductBanners) {
        const {
            immHireCardRevolving,
            flagBasedFeatures
        } = this.props;

        const enabledRevolving = immHireCardRevolving.get('enabled');

        const filteredItems = orderedProductBanners.filter((bannerKey) => {
            if ((bannerKey === CARDS_PRODUCT.REVOLVING && !enabledRevolving)) {
                return false;
            }

            return this.showCardProductByFeatureToggling(bannerKey)

        });
        const title = formatText('cardsHiringDropdown-title');
        const items = filteredItems.map((bannerKey) => {
            const banner = getCardsProductBanners(flagBasedFeatures)[bannerKey];
            return {
                link: banner.link,
                text: formatText(banner.title),
                disabled: (!canHireCard(flagBasedFeatures, banner.featureTogglingKey, banner.featureTogglingFn ))
            }
        });

        const finalItems = items.filter(item => !item.disabled)
        return (
            <PopoverNavigationButton
                title={title}
                items={finalItems}
            />
        );
    }

    render() {
        const userOwnedProductBannersCode = this.getUserOwnedProductBannersCode(this.props.immCards);
        const orderedProductBanners = this.getProductBannersOrder(userOwnedProductBannersCode);
        const dropdown = this.buildProductDropdown(orderedProductBanners);
        return dropdown;
    }

}

CardsProductDropdown.propTypes = {
    amount: PropTypes.number,
    immCards: PropTypes.object.isRequired,
    immHireCardRevolving: PropTypes.object.isRequired,
    flagBasedFeatures: PropTypes.object.isRequired
};

module.exports = withFeatureToggling(CardsProductDropdown)
